import React from 'react';
import {NavLink} from 'react-router-dom';
import {APP_ROUTES} from '../../../../constants';
import './style.scss';
import {BigGreenButton, Coins} from '../../../../components';
import gameResultKwami from '../../../../../images/game-result-kwami.png';

export const GameResult = ({coins, bonus, onRestart}) => {
  return <div className="app-game-result">
    <img src={gameResultKwami} alt="" className="app-game-result--image"/>
    <div className="app-game-result--amount">
      <div className="app-game-result--title">Твой результат</div>
      <div className="app-game-result--coins"><Coins coins={coins.toLocaleString('en-US')} big={true}/></div>
      {bonus > 0 && <div className="app-game-result--bonus"><Coins coins={bonus.toLocaleString('en-US')} big={false}/> <span>бонус</span></div>}
    </div>
    <div className="app-game-result--buttons">
      <BigGreenButton onClick={() => onRestart()}>Играть еще</BigGreenButton>
      <NavLink to={APP_ROUTES.HOME}><BigGreenButton ghost={true} onClick={() => onRestart()}>На главную</BigGreenButton></NavLink>
    </div>
    <svg className="app-game-result--shadow" width="312" height="312" viewBox="0 0 312 312" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="156" cy="156" r="156" fill="black"/>
    </svg>
  </div>;
}
